// import Navigation from './navigation';
import NavClick from "./NavClick";
import Accordion from './accordion';
import Lightbox from './lightbox';
import Skip from './skip-links';

// Navigation.init();
Skip.init();
NavClick.init();


let accordion = document.getElementsByClassName('accordion');
if(accordion.length > 0) {
  Accordion.init();

}

let video = document.getElementsByClassName('video');
if(video.length > 0) {
  Lightbox.init();

}
